import { Skeleton } from "@/components/ui/skeleton";

export const FileUploadLoading = () => (
    <div className="space-y-4">
        <div className="flex flex-wrap gap-4">
            <div className="flex-1 border-2 border-dashed rounded-lg p-4 min-h-32">
                <div className="flex flex-col items-center justify-center h-full">
                    <Skeleton className="h-10 w-10 rounded-full" />
                    <div className="mt-4 space-y-2">
                        <Skeleton className="h-4 w-40" />
                        <Skeleton className="h-3 w-32" />
                    </div>
                </div>
            </div>
            <div className="w-48 bg-gray-50 rounded-lg p-3">
                <div className="flex flex-col space-y-2">
                    <Skeleton className="h-4 w-24" />
                    <Skeleton className="h-24 w-full" />
                </div>
            </div>
        </div>
    </div>
);